/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useCallback } from "react";
import { withTranslation } from "react-i18next";
import { Label } from "reactstrap";

import { isArray } from "../../../Libs/CustomMethods/customMethods";

import Select from "react-select";

export const FilterSelect = ({
  t,
  name,
  filterItemExtraStyle,
  filterItemIcon,
  filterItemTitle,
  isLoadingData,
  data,
  onChange,
  defaultValue,
  isMulti,
  maxSelection,
  showToast,
}) => {
  // Utils
  const getFixed = (array) => (array ? array.filter((v) => v.isFixed) : []);
  const getNoFixed = (array) => (array ? array.filter((v) => !v.isFixed) : []);
  const convertDataToOpts = useCallback(
    (data, loading) => {
      let options = [];

      if (isArray(data) && data.length > 0) {
        data.forEach((option, key) => {
          options.push({
            key: key,
            value: option?.id,
            label: option?.name,
            isFixed: option?.isFixed,
          });
        });
      }
      if (loading) {
        options.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      }
      if (isArray(data) && data.length === 0 && !loading) {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }

      return options;
    },
    [t]
  );

  const styles = {
    multiValue: (base, state) => {
      return state.data.isFixed ? { ...base, backgroundColor: "gray" } : base;
    },
    multiValueLabel: (base, state) => {
      return state.data.isFixed
        ? { ...base, fontWeight: "bold", color: "white", paddingRight: 6 }
        : base;
    },
    multiValueRemove: (base, state) => {
      return state.data.isFixed ? { ...base, display: "none" } : base;
    },
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "0.5rem",
        height: "0.5rem",
      },
      "::-webkit-scrollbar-track": {
        borderRadius: "0.5rem",
      },
      "::-webkit-scrollbar-thumb": {
        background: "radial-gradient(circle, #8d8e90 100%, #f9d4ff 100%)",
        borderRadius: "10px",
      },
    }),
  };

  const [value, setValue] = useState(null);
  const [options, setOptions] = useState([]);

  const updateValue = useCallback(
    (value) => {
      if (isMulti) {
        if (value?.length > 0) {
          value = getNoFixed(value);
        } else {
          value = getFixed(options);
        }
      }
      setValue(value);
    },
    [isMulti, options]
  );

  const handleChange = (value) => {
    if (isMulti && maxSelection && value?.length > maxSelection) {
      showToast?.("error", t("Maximum of 20 skills selected"));
      return;
    }
    if (isMulti) {
      onChange(name, getNoFixed(value));
    } else {
      onChange(name, value);
    }
    updateValue(value);
  };

  useEffect(() => {
    if (options.length > 0) {
      let value = null;
      if (defaultValue?.[name]) {
        // There is value saved
        let target = defaultValue?.[name];
        if (isMulti) {
          value = options.filter((e) => target.includes(e.value));
        } else {
          value = options.find((e) => target === e.value);
        }
      } else {
        // There is no value saved (defaultValue)
        if (isMulti) {
          value = [];
        } else {
          value = options[0];
        }
      }
      updateValue(value);
    }
  }, [defaultValue, options, updateValue, isMulti, name]);

  useEffect(() => {
    if (isArray(data)) {
      let opt = convertDataToOpts(data, isLoadingData);
      setOptions(opt);
    }
  }, [data, isLoadingData, convertDataToOpts]);

  return (
    <div className={`${filterItemExtraStyle}`}>
      <Label className="font-size-13">
        {filterItemIcon && (
          <i className={`${filterItemIcon} font-size-13 mr-2`} />
        )}
        {filterItemTitle}
      </Label>
      <div className="select2-container">
        <Select
          classNamePrefix="select2-selection"
          styles={styles}
          placeholder={t("Choose") + "..."}
          options={options.filter((v) => !v.isFixed)}
          onChange={handleChange}
          value={value}
          isClearable={isMulti && getNoFixed(value).length > 0}
          isLoading={isLoadingData}
          isMulti={isMulti}
        />
      </div>
    </div>
  );
};
export default withTranslation()(FilterSelect);
